import type { FilesProxySchemaWithId } from '@iconik-io/iconik-api/src/services/files';

/**
 * Picks the proxy that represents an asset from a list, preferring proxies
 * without the `is_multichannel` flag. A multi-channel proxy exists only as an
 * extra rendition, so its presence must never change which proxy is treated as
 * the asset's primary one. Returns the first non-multi-channel proxy in the
 * given list, falling back to the first proxy when they are all multi-channel.
 * The list order is used as-is (this helper does not sort), so callers decide
 * precedence by ordering the list themselves.
 */
export function preferNonMultichannelProxy(
  proxies: FilesProxySchemaWithId[],
): FilesProxySchemaWithId | undefined {
  return proxies.find((proxy) => !proxy.is_multichannel) ?? proxies[0];
}
